/**
 * Integrytas Group - Common Security Module (CSM)
 * Page: CSM.SYSTEM.BULK_IMPORT
 *
 * Thin shell — all logic lives in <ImportEngine>.
 * To embed a pre-configured import in another page:
 *
 *   import { ImportEngine } from '../../components/common/ImportEngine';
 *   <ImportEngine session={session} initialTableName="my_table" lockTable />
 */

import { useTranslation } from 'react-i18next';
import type { AuthSession } from '../../types/auth';
import { ImportEngine } from '../../components/common/ImportEngine';
import { PersonalizationProvider, PersonalizationToggle } from '../../components/personalization';

export interface BulkImportPageProps { session: AuthSession; }

export function BulkImportPage({ session }: BulkImportPageProps) {
  return (
    <PersonalizationProvider pageCode="CSM.SYSTEM.BULK_IMPORT" session={session}>
      <BulkImportPageInner session={session} />
    </PersonalizationProvider>
  );
}

function BulkImportPageInner({ session }: BulkImportPageProps) {
  const { t } = useTranslation();
  return (
    <div className="flex h-full flex-col">
      <div className="flex h-10 shrink-0 items-center gap-2 border-b border-csm-border bg-white px-3">
        <span className="csm-page-title">{t('bulkImport.title', 'Bulk Import')}</span>
        <div className="ml-auto"><PersonalizationToggle /></div>
      </div>
      <div className="flex-1 overflow-auto">
        <ImportEngine session={session} />
      </div>
    </div>
  );
}
